"use client";
import * as React from "react";
const SvgGlassDamageFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m15.95 8.93-1.63-6.76A2.1 2.1 0 0 0 12.24.5H3.75c-1 0-1.86.7-2.08 1.68L.05 8.93a2.12 2.12 0 0 0 2.08 2.57h11.74a2.13 2.13 0 0 0 2.08-2.57m-1.36 1.03a1 1 0 0 1-.72.35H2.13c-.39 0-.62-.22-.72-.35s-.27-.4-.19-.76l1.63-6.77a.9.9 0 0 1 .91-.73h5.42l.03.08 1.3 1.81-1.24 1.24a.6.6 0 0 0-.03.82l1.28 1.45a.6.6 0 0 0 .85.05.6.6 0 0 0 .05-.85l-.9-1.03 1.2-1.2a.6.6 0 0 0 .06-.77l-1.15-1.6h1.62c.43 0 .81.3.91.75l1.62 6.73a1 1 0 0 1-.18.78z" }));
export {
  SvgGlassDamageFilled as default
};
